import React from 'react';
import { Chip, SxProps } from '@mui/material';
import { Colors } from '../../../utils/theme';

const chipStyles: SxProps = {
  color: Colors.main,
  fontSize: 14,
  fontWeight: 'normal',
  background: '#69AAF333',
  '&:active, &:focus': {
    background: '#69AAF333'
  }
};

const deleteIconStyles: SxProps = {
  color: Colors.skyBlue,
  width: 28,
  height: 28,
  '&:hover': {
    color: Colors.main
  }
};

interface IProps {
  id: string;
  label: string;
  onDelete: () => void;
}

const EpraChip: React.FunctionComponent<IProps> = ({ id, label, onDelete }: IProps) => {
  return (
    <Chip
      id={id}
      data-testid={id}
      label={label}
      onDelete={onDelete}
      sx={{
        ...chipStyles,
        '.MuiChip-deleteIcon': deleteIconStyles
      }}
    />
  );
};

export default EpraChip;
